<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import ResponsiveDebugger from './components/ResponsiveDebugger.vue'
import { canonicalManager } from './utils/canonicalManager'
import { structuredDataManager } from './utils/structuredDataManager'
import { watch } from 'vue'
import type { RouteLocationNormalized } from 'vue-router'

const route = useRoute()

// 設置 Canonical URL 和 hreflang
watch(
  () => route.fullPath,
  (newPath, oldPath) => {
    if (newPath !== oldPath) {
      const locale = (route.params.locale as string) || 'zh-TW'
      canonicalManager.setCanonicalURL(newPath, locale)
      canonicalManager.setHreflangTags(newPath)
      
      // 清除非全域的 Schema
      structuredDataManager.clearInjectedSchemas('WebPage')
      structuredDataManager.clearInjectedSchemas('Tool')
    }
  },
  { immediate: true }
)

// 設置全域結構化資料 (僅執行一次)
structuredDataManager.setGlobalSchemas()

const isDev = import.meta.env.DEV
</script>

<style>
#app {
  min-height: 100vh;
  background-color: #f8fafc;
}
</style> 